import { Reveal, SectionHeader } from "./Reveal";
import { PROCESS_STEPS } from "../data/content";

export const Process = () => (
  <section data-testid="process-section" className="border-t border-white/10 bg-ink-2 py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <SectionHeader eyebrow="The Legacy Process" title="From Vision to Completion" />

      <div className="mt-16 grid gap-px border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-4">
        {PROCESS_STEPS.map((step, i) => (
          <Reveal key={step.number} delay={0.1 * i}>
            <div
              data-testid={`process-step-${i}`}
              className="group relative h-full bg-ink-2 p-8 transition-colors duration-500 hover:bg-ink-3 md:p-10"
            >
              <span className="font-serif text-6xl font-normal text-gold/25 transition-colors duration-500 group-hover:text-gold/60" aria-hidden="true">
                {step.number}
              </span>
              <h3 className="mt-6 font-serif text-2xl font-medium text-white">{step.title}</h3>
              <p className="mt-4 text-sm leading-relaxed text-gray-400">{step.description}</p>
              <span
                className="mt-8 block h-px w-8 bg-gold/40 transition-all duration-500 group-hover:w-full group-hover:bg-gold"
                aria-hidden="true"
              />
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
